import { type DashboardId } from '@terros/common'

type InputDashboard = {
  dashboardId: DashboardId
  name?: string
  order?: number
}

/** The viewer's dashboard order: explicit `order`, then name, then id for stability. */
export const sortDashboardsByOrder = (a: InputDashboard, b: InputDashboard): number => {
  const orderResult = (a.order ?? 0) - (b.order ?? 0)
  if (orderResult !== 0) return orderResult

  const nameResult = (a.name ?? '').localeCompare(b.name ?? '', undefined, { sensitivity: 'base' })
  if (nameResult !== 0) return nameResult

  return a.dashboardId.localeCompare(b.dashboardId)
}
